import { Characters, ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const attributes = {
  password: Characters.preset.halfWidth({ maxLen: 256, required: true }),
  note: Characters.preset.freeFormat(),
  token: Characters.preset.halfWidth(),
  expiresAt: Characters.preset.freeFormat(),
};

const names = {
  note: ItemName.of([Locale.ja, '備考']),
  password: ItemName.of([Locale.ja, 'パスワード']),
  token: ItemName.of([Locale.ja, 'トークン']),
  expiresAt: ItemName.of([Locale.ja, '有効期限']),
  maintenance: ItemName.of([Locale.ja, 'トークンメンテナンス']),
  create: ItemName.of([Locale.ja, 'トークン生成']),
  copyToClipBoard: ItemName.of([Locale.ja, 'クリップボードへコピー']),
};

const webhookToken = {
  attributes,
  names,
};

export { webhookToken };
